export default __webpack_public_path__ + "static/media/add.bb2625a8.svg";